<!-- SAP Submittal Errors Dialog -->
<!-- Warning mode: Shows pre-submit warnings with Continue/Cancel (desktop: SummaryEstimateErrorDialog) -->
<!-- Blocking mode: Shows blocking errors with Close only (desktop: InvalidSalesOfficeMsgDialog / SAPNegativeMarginMsgDialog) -->

<div mat-dialog-title class="dialog-info horizontal-padding m-0">
    <label class="dialogTitle">
        @if (isBlockingMode) {
        {{ 'SAP_SUBMITTAL_ERROR_TITLE' | translate }}
        } @else {
        {{ 'SAP_SUBMITTAL_WARNINGS_TITLE' | translate }}
        }
    </label>
    <button type="button" class="btn-close btn-close-white shadow-none dialogCross" [mat-dialog-close]></button>
</div>

<mat-dialog-content class="horizontal-padding d-flex">
    <div>
        @if(isBlockingMode) {
        <mat-icon class="icon-class cancel">cancel</mat-icon>
        } @else {
        <mat-icon class="icon-class warning">error</mat-icon>
        }
    </div>

    <div class="horizontal-padding">
        @if (isBlockingMode && !hasPreSubmitErrors) {
        <!-- Blocking errors -> invalid sales office / invalid segment / negative margin -->
        <div>
            @if (data.isSalesOfficeInvalid || data.isSegmentInvalid) {
            <p>{{ 'SAP_SUBMITTAL_ERROR_INVALID_SALES_OFFICE_SEGMENT' | translate }}</p>
            }
            @if (data.isNegativeMargin) {
            <p>{{ 'SAP_SUBMITTAL_ERROR_NEGATIVE_MARGIN' | translate }}</p>
            }
        </div>
        } @else {
        <div class="errors-list">
            <!-- Pre-submit errors list -->
            <p>{{ 'SAP_SUBMITTAL_WARNINGS_MESSAGE' | translate }}</p>
            <p>
                <span>{{ 'CLICK' | translate }} </span>
                <a target="_blank" class="custom-anchor"
                href="https://siemensnam.sharepoint.com/teams/DocumentCenter/Published%20Documents/Field_Operations_Sales_Policy.pdf" >
                     {{ 'HERE' | translate }}</a>
                <span> {{ 'POLICY_VIOLATION_PARAGRAPH_2' | translate }}</span>
            </p>
            <ul class="errors-list gap-2">
                @if (data.isProposalError) {
                <li>
                    <span>{{ 'SAP_SUBMITTAL_WARNING_PROPOSAL' | translate }}</span>
                </li>
                }
                @if (data.isCostReviewError) {
                <li>
                    <span>{{ 'SAP_SUBMITTAL_WARNING_COST_REVIEW' | translate }}</span>
                </li>
                }
                @if (data.isOpportunityError) {
                <li>
                    <span>{{ 'SAP_SUBMITTAL_WARNING_OPPORTUNITY' | translate }}</span>
                </li>
                }
                @if (data.isSummaryEstimateError) {
                <li>
                    <span>{{ 'SAP_SUBMITTAL_WARNING_SUMMARY_ESTIMATE' | translate }}</span>
                </li>
                }
            </ul>
        </div>
        }
        @if(!isBlockingMode) {
        <p class="warnings-footer">{{ 'SAP_SUBMITTAL_WARNINGS_CONTINUE_QUESTION' | translate }}</p>
        }
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-actions-style">
    @if (isBlockingMode) {
    <button mat-raised-button color="primary" mat-dialog-close>{{ 'CLOSE' | translate }}</button>
    } @else {
    <button mat-raised-button color="primary" (click)="onContinue()">{{ 'CONTINUE' | translate }}</button>
    <button mat-raised-button color="warn" mat-dialog-close>{{ 'CANCEL' | translate }}</button>
    }
</mat-dialog-actions>